import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import './menu-item.css';

class MenuItem extends React.Component {
    render() {
        var isActive = this.context.router.route.location.pathname === this.props.to;
        var className = isActive ? 'menuItem px-5 py-2 active' : 'menuItem px-5 py-2';
        var icon = "fa-fw " + this.props.icon;

        return (
            <Link to={this.props.to}>
                <div className={className}>
                    {this.props.name}
                    <i className={icon}></i>
                </div>
            </Link>
        );
    }
}

MenuItem.contextTypes = {
    router: PropTypes.object
};

export default MenuItem;


// WEBPACK FOOTER //
// ./src/components/sidebar/menu-item/menu-item.js